import React from 'react';
import onlyUpdateForKeys from 'recompose/onlyUpdateForKeys';
import flow from 'lodash/fp/flow';
import isEmpty from 'lodash/isEmpty';
import { WorkbookState } from 'types';
import { Document, Page, pdfjs } from 'react-pdf';
import { translate } from 'translations/translator';
import CommonTranslationVariant from 'translations/variants/common';

const getTranslation = (key: CommonTranslationVariant) => translate('common', key);
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

type Props = {
  workbook: WorkbookState;
  currentPage: number;
  width: number;
};

const SinglePageModalViewer: any = ({ workbook, currentPage, width }: Props) => {
  return (
    <div
      style={{
        userSelect: 'none',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: '#454545'
      }}
    >
      {!isEmpty(workbook.bookUrl) && (
        <Document
          file={workbook.bookUrl}
          options={{ disableAutoFetch: true }}
          loading={getTranslation(CommonTranslationVariant.loading)}
          renderMode="canvas"
        >
          <Page
            pageNumber={currentPage + workbook.pageOffset}
            width={width - 50}
            loading={getTranslation(CommonTranslationVariant.loading)}
          />
        </Document>
      )}
    </div>
  );
};

export default flow(onlyUpdateForKeys(['currentPage']))(SinglePageModalViewer) as any;
